import TodayContainer from '../components/today/today-redux'

export default TodayContainer
